export function TrustAsHtml($sce) {
    'ngInject';
    return (input) => {
        return $sce.trustAsHtml(input);
    }
} 


// WEBPACK FOOTER //
// ./src/app/shared/filters/TrustAsHtml.js